module.exports = __webpack_public_path__ + "c018b04d0c365ae0871c99fef92b9297.svg";